export const reportImages = {
  thickness: 'assets/img/report/thickness.svg',
  top: 'assets/img/report/pt.svg',
  height: 'assets/img/report/height.svg',
  width: 'assets/img/report/width.svg',
  borderRadius: 'assets/img/report/borderRadius.svg',
  right: 'assets/img/report/pr.svg',
  bottom: 'assets/img/report/pb.svg',
  left: 'assets/img/report/pl.svg',
  fontSize: 'assets/img/report/fontSize.svg',
  fontWeight: 'assets/img/report/fontWeight.svg',
  latterSpacing: 'assets/img/report/latterSpacing.svg',
  lineHeight: 'assets/img/report/lineHeight.svg',
  table_icon: 'assets/img/report/table.svg',
  widget_one: 'assets/img/report/widget_one.svg',
  count_box: 'assets/img/report/count_box.svg',
  heading: 'assets/img/report/heading.svg',
  view_icon: 'assets/img/report/view.svg',
  ypm_icon: 'assets/img/report/ypm.svg',
  vec_icon: 'assets/img/report/vec.svg',
  header: 'assets/img/report/header.svg',
  footer: 'assets/img/report/footer.svg',
  summary: 'assets/img/report/summary.svg',
  view: 'assets/img/report/view.svg',
  spacer: 'assets/img/report/spacer.svg',
  divider: 'assets/img/report/divider.svg',
  page_break: 'assets/img/report/page_break.svg',
  pipeline: 'assets/img/report/pipeline.svg',
  applications: 'assets/img/report/applications.svg',
  top_app: 'assets/img/report/top_app.svg',
  prospective: 'assets/img/report/prospective.svg',
  listing_info: 'assets/img/report/listing_info.svg',
  image: 'assets/img/report/image.svg',
  chart: 'assets/img/report/chart.svg',
  pipeline_status: 'assets/img/report/pipeline_status.svg',
  project_prospects: 'assets/img/report/project_prospects.svg',
  project_report: 'assets/img/report/project_report.svg',
  lastWeek: 'assets/img/report/lastWeek.svg',
  drag: 'assets/img/report/drag.svg',
  minus: 'assets/img/report/minus.svg',
  vec_pending_icon: 'assets/img/report/vec_pending.svg',
  plus_icon: 'assets/img/report/plus.svg',
  history_icon: 'assets/img/report/history.svg',
  note_icon: 'assets/img/report/note.svg',
  eye_icon: 'assets/img/report/eye.svg',
  setting_icon: 'assets/img/report/setting.svg',
  pencil_icon: 'assets/img/report/pencil.svg',
  crop: 'assets/img/report/crop.svg',
  ad_chart_icon: 'assets/img/report/adchart.svg',
  office_footer: 'assets/img/report/office_footer.svg',
  heading_desc: 'assets/img/report/heading_desc.svg',
  widget_icon: 'assets/img/report/widget.svg',
  temp_icon: 'assets/img/report/temp.svg',
  project: 'assets/img/report/project.svg',
  blank_template: 'assets/img/report/blank_template.svg',
  listing: 'assets/img/report/listing.png',
  demogrphic: 'assets/img/report/demogrphic.svg',
  text_icon: 'assets/img/report/text.svg',
  upload_image: 'assets/img/report/upload.png',
  close_image: 'assets/img/report/close.png',
  page1: 'assets/img/report/page1.svg',
  page2: 'assets/img/report/page2.svg',
  page3: 'assets/img/report/page3.svg',
  // Per-template picker thumbnails (rp-step-2's "Select Template" grid) — each reflects that
  // template's actual widget layout (KPI strip shape, table vs. chart grid, tabs vs. single page,
  // etc.) instead of every template sharing the one generic `page1` screenshot above.
  tpl_agent_report_weekly: 'assets/img/report/templates/agent-report-weekly.svg',
  tpl_developer_weekly_report: 'assets/img/report/templates/developer-weekly-report.svg',
  tpl_agent_report: 'assets/img/report/templates/agent-report.svg',
  tpl_developer_insights: 'assets/img/report/templates/developer-insights.svg',
  tpl_agent_lead_insights: 'assets/img/report/templates/agent-lead-insights.svg',
  tpl_developer_report: 'assets/img/report/templates/developer-report.svg',
  // Precinct Insight is a precinct-scoped twin of Project Insights with an identical layout, so it
  // deliberately shares that template's thumbnail until artwork of its own is supplied.
  tpl_precinct_insight: 'assets/img/report/templates/developer-report.svg',
  // New Project Insight is a duplicate of Project Insights carrying the reported fixes, same
  // reasoning as Precinct Insight above: identical layout, so it shares the thumbnail.
  tpl_new_project_insight: 'assets/img/report/templates/developer-report.svg',
  tpl_project_insights_final: 'assets/img/report/templates/developer-report.svg',
  tpl_ypm_report: 'assets/img/report/templates/ypm-report.svg',
  tpl_project_weekly: 'assets/img/report/templates/project-weekly.svg',
  tpl_project_monthly: 'assets/img/report/templates/project-monthly.svg',
  vbarchar_icon: 'assets/img/report/chart/vbarchar.svg',
  hbarchar_icon: 'assets/img/report/chart/hbarchart.svg',
  gvbar_icon: 'assets/img/report/chart/gvbar.svg',
  ghbar_icon: 'assets/img/report/chart/ghbar.svg',
  svbar_icon: 'assets/img/report/chart/svbar.svg',
  shbar_icon: 'assets/img/report/chart/shbar.svg',
  nvbar_icon: 'assets/img/report/chart/nvbar.svg',
  nhbar_icon: 'assets/img/report/chart/nhbar.svg',
  pie_icon: 'assets/img/report/chart/pie.svg',
  ad_pie_icon: 'assets/img/report/chart/adpie.svg',
  pie_grid_icon: 'assets/img/report/chart/piegrid.svg',
  line_icon: 'assets/img/report/chart/line.svg',
  polar_icon: 'assets/img/report/chart/polar.svg',
  box_icon: 'assets/img/report/chart/box.svg',
  heat_icon: 'assets/img/report/chart/heat.svg',
  number_icon: 'assets/img/report/chart/number.svg',
  tree_icon: 'assets/img/report/chart/tree.svg',
  gauge_icon: 'assets/img/report/chart/gauge.svg',
  reference_icon: 'assets/img/report/chart/reference.svg',
  linear_gauge_icon: 'assets/img/report/chart/linear-gauge.svg',
  report_1_icon: 'assets/menu-customisation-icons/Report/report1.svg',
  report_2_icon: 'assets/menu-customisation-icons/Report/report2.svg',
  report_3_icon: 'assets/menu-customisation-icons/Report/report3.svg',
  report_4_icon: 'assets/menu-customisation-icons/Report/report4.svg',
  report_5_icon: 'assets/menu-customisation-icons/Report/report5.svg',
  report_6_icon: 'assets/menu-customisation-icons/Report/report6.svg',
  report_7_icon: 'assets/menu-customisation-icons/Report/report7.svg',
  report_8_icon: 'assets/menu-customisation-icons/Report/report8.svg',
  report_9_icon: 'assets/menu-customisation-icons/Report/report9.svg',
  report_10_icon: 'assets/menu-customisation-icons/Report/report10.svg',
  report_11_icon: 'assets/menu-customisation-icons/Report/report11.svg',
  report_12_icon: 'assets/menu-customisation-icons/Report/report12.svg',
  data_sheet_icon: 'assets/img/bed-bath/data-sheet.svg',
  filter_icon: 'assets/img/bed-bath/Filter.svg',
  table_light_icon: 'assets/img/bed-bath/Table_light.svg',
  lead_icon: 'assets/img/bed-bath/lead.svg',
  home_icon: 'assets/img/bed-bath/home.svg',
  contact_icon: 'assets/img/bed-bath/contact.svg',
  task_icon: 'assets/img/bed-bath/task.svg',
  image_icon: 'assets/img/Iconly_Light_Image.svg',
  project_icon: 'assets/img/bed-bath/project.svg',
  start_icon: 'assets/img/bed-bath/start.svg',
  end_icon: 'assets/img/bed-bath/end.svg',
  entity_icon: 'assets/img/bed-bath/entity.svg',
  delete_icon: 'assets/img/menuIcon/delete_icon.svg',
  weekly_sale_icon: 'assets/img/pdf-export-modal/weekly-sales.svg',
  monthly_Sale_icon: 'assets/img/pdf-export-modal/monthly-sales.svg',
  sale_summary_icon: 'assets/img/pdf-export-modal/sales-summary.svg',
};
